import http, { handleApiResponse, checkResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import StornoSummaryInvoice from "../models/StornoSummaryModel";

export default class StornoSummaryApi {
  public static async StornoSummary(invoices: StornoSummaryInvoice[]): Promise<boolean> {
    return await http.post<ApiResponse<boolean>>("currentAccount/storno-summary/create", invoices).then(handleApiResponse);
  }
}
